const deleteCookie = (cookieName: string) => {
    document.cookie = cookieName + '=; path=/; expires=Thu, 01 Jan 1970 00:00:01 GMT; domain=.scholastic.com';
}

export default deleteCookie;